// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"334":"4559568c","391":"69b51223"}[chunkId] || chunkId) + "." + {"96":"39414be689291e45","112":"30f9c3911ea5736d","334":"4866230094543c5c","391":"0800cbade1d50fd2","617":"0149fb7957cb13de","958":"eae05fae570b4af8"}[chunkId] + ".js";
};